export default __webpack_public_path__ + "static/Entenda0060-de53cc7a12d71b1d2ef7b423c573cc1e.jpg";